import { WidthContainer } from '@pata-app/ui-document';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { HeroContentContainer, HeroHeading, HeroSectionContainer, HeroSubHeading } from './heroSection.styled';
import SearchBox from './searchBox/searchBox';

const HeroSection = () => {
  return (
    <HeroSectionContainer>
      <Image
        alt="Pet owner holding happy pug used Pata to book pet care services"
        width={2500}
        height={2000}
        src="https://static.patacdn.net/images/image-hero-man-holding-pug.png"
      />

      <WidthContainer noBackground>
        <HeroContentContainer>
          <HeroHeading>
            <span>Find and book</span>
            <span>Local pet care services</span>
          </HeroHeading>
          <HeroSubHeading>
            Trusted pet care pros near you from groomers, trainers and walkers to vets and sitters.
          </HeroSubHeading>
          <SearchBox />
        </HeroContentContainer>
      </WidthContainer>
    </HeroSectionContainer>
  );
};

export default HeroSection;
